import React from "react";
import { ColorConfigs } from './../../configurations';
function InfoBars() {
    return (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M0 13.3335H3.73387V19.9451H0V13.3335Z", fill: ColorConfigs.pink }),
        React.createElement("path", { d: "M5.42188 8.88867H9.15575V19.9723H5.42188V8.88867Z", fill: ColorConfigs.yellow3 }),
        React.createElement("path", { d: "M10.8438 4.44434H14.5776V19.9999H10.8438V4.44434Z", fill: ColorConfigs.blue }),
        React.createElement("path", { d: "M16.2656 0H19.9995V19.9449H16.2656V0Z", fill: ColorConfigs.green })));
}
export default InfoBars;
//# sourceMappingURL=info-bars.js.map